export const isEmptyMarkdownString = (content?: string): boolean => {
  const str = content?.trim().replace(/\n|\r|\u200B/g, '');
  return !str;
};
